import apiClient from './client';

export function fetchProfile() {
  return apiClient.get('/account/me');
}

export function updateProfile(payload) {
  return apiClient.put('/account/me', payload);
}

export function fetchSubscriptionRequests() {
  return apiClient.get('/account/subscription-requests');
}

export function submitSubscriptionRequest(payload) {
  return apiClient.post('/account/subscription-requests', payload);
}

export function cancelSubscriptionRequest(requestId) {
  return apiClient.post(`/account/subscription-requests/${requestId}/cancel`);
}
